<div class="websocket-debug-panel" 
     [class.open]="isPanelOpen$ | async"
     [style.width.px]="panelWidth">
  
  <div class="resize-handle" (mousedown)="onResizeStart($event)"></div>

  <div class="panel-content">
    <div class="panel-header">
      <h2>WebSocket Debug Panel</h2>
      <div class="header-actions">
        <span class="keyboard-hint">Ctrl+Shift+X</span>
        <button
          mat-icon-button
          class="toggle-button"
          ixTest="debug-panel-toggle"
          [attr.aria-label]="(isPanelOpen$ | async) ? 'Close debug panel' : 'Open debug panel'"
          (click)="togglePanel()"
        >
          <ix-icon name="mdi-close"></ix-icon>
        </button>
      </div>
    </div>
    
    <mat-tab-group 
      class="panel-tabs" 
      [selectedIndex]="selectedTabIndex$ | async"
      (selectedIndexChange)="onTabChange($event)">
      <mat-tab label="Messages">
        <ix-websocket-tab></ix-websocket-tab>
      </mat-tab>
      <mat-tab label="Mock Configurations">
        <ix-mock-configurations-tab></ix-mock-configurations-tab>
      </mat-tab>
      <mat-tab label="Enclosure Mock">
        <ix-enclosure-mock-tab></ix-enclosure-mock-tab>
      </mat-tab>
    </mat-tab-group>
  </div>
</div>
